import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import Select from 'react-select';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment-timezone';
import { v4 as uuid } from 'uuid';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Button } from 'reactstrap';
import LoadingOverlay from 'react-loading-overlay';
import { isEmpty, join } from 'lodash';

import { debounce } from '../commons/browser';
import { getUser, cleanRedirectState, getDMEClients } from '../state/services/authService';
import { saveBooking } from '../state/services/bookingService';
import { getContactsWithPrefix, getAddressesWithPrefix, getContactsWithStoreNo, getContactsOfClient } from '../state/services/elasticsearchService';
import { getPackageTypes } from '../state/services/extraService';
import SimpleLineModal from '../components/CommonModals/SimpleLineModal';
import SimpleLineDetailModal from '../components/CommonModals/SimpleLineDetailModal';
import ConfirmModal from '../components/CommonModals/ConfirmModal';

import { validateEmail, isValidPhoneNumber } from '../commons/validations';
import { BOOKING_CATEGORIES, BOOKING_PRIORITIES } from '../commons/constants';
import { sortByPostalCodeAndSuburb } from '../commons/addresses';
import DmeDateTimePicker from '../components/DmeDateTimePicker';
import { resetQuickQuoteBookingData } from '../state/actions/bookingActions';
import { isGWSubClient } from '../commons/helpers';

class NewBookingPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            puPrefix: '',
            dePrefix: '',
            puFromDT: null,
            puByDT: null,
            deFromDT: null,
            deByDT: null,
            puSuburb: { value: '' },
            deToSuburb: { value: '' },
            formInputs: {
                'b_client_name': props.clientname,
                'has_plain_pallet': false,
                'has_chep_pallet': false,
                'has_loscam_pallet': false,
            },
            lines: [],
            selectedLine: null,
            selectedLineId: null,
            selectedLineDetail: null,
            selectedLineDetailKey: null,
            isShowSimpleLineModal: false,
            isShowSimpleLineDetailModal: false,
            isShowConfirmModal: false,
            isSavingBooking: false,
            isLoadingPUContacts: false,
            isLoadingDEContacts: false,
            validationErrors: {},
            isShowCategory: true,
        };

        this.toggleSimpleLineModal = this.toggleSimpleLineModal.bind(this);
        this.toggleSimpleLineDetailModal = this.toggleSimpleLineDetailModal.bind(this);
        this.toggleShowConfirmModal = this.toggleShowConfirmModal.bind(this);
    }

    static propTypes = {
        getContactsOfClient: PropTypes.func.isRequired,
        getContactsWithPrefix: PropTypes.func.isRequired,
        getAddressesWithPrefix: PropTypes.func.isRequired,
        getContactsWithStoreNo: PropTypes.func.isRequired,
        getPackageTypes: PropTypes.func.isRequired,
        history: PropTypes.object.isRequired,
        redirect: PropTypes.bool.isRequired,
        location: PropTypes.object.isRequired,
        cleanRedirectState: PropTypes.func.isRequired,
        getDMEClients: PropTypes.func.isRequired,
        saveBooking: PropTypes.func.isRequired,

        // Data
        clientname: PropTypes.string.isRequired,
        clientId: PropTypes.string,
        username: PropTypes.string.isRequired,
        packageTypes: PropTypes.array,
        puContacts: PropTypes.array,
        deContacts: PropTypes.array,
        puAddresses: PropTypes.array,
        deToAddresses: PropTypes.array,
        booking: PropTypes.object,
        dmeClients: PropTypes.array.isRequired,
        errorMessage: PropTypes.string,
        quickQuoteBookingData: PropTypes.object,
    };

    static defaultProps = {
        clientname: ''
    };

    componentDidMount() {
        this.props.getPackageTypes();
        this.props.getDMEClients();
        if (this.props.clientname === 'Yale Prima') {
            this.setYalePrimaDEAddr({});
        }
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        const { redirect, clientname, booking, puContacts, deContacts, errorMessage, quickQuoteBookingData } = newProps;
        const { isLoadingPUContacts, isLoadingDEContacts } = this.state;
        const currentRoute = this.props.location.pathname;
        const hideCategoryClients = ['Gebrüder Weiss', 'Dioni', 'Tixana Pty Ltd', 'Osmoflo', 'Faresin Australia'];
        const isShowCategory = !hideCategoryClients.includes(clientname);
        this.setState({ isShowCategory });

        if (redirect && currentRoute != '/') {
            localStorage.setItem('isLoggedIn', 'false');
            this.props.cleanRedirectState();
            this.props.history.push('/');
        }

        if (clientname && clientname !== 'dme') {
            const { formInputs } = this.state;
            this.setState({
                formInputs: {
                    ...formInputs,
                    b_client_name: clientname
                }
            });
        }

        if (clientname && clientname === 'Yale Prima' && clientname != this.props.clientname) {
            this.setYalePrimaDEAddr({});
        }

        if (clientname && clientname === 'Gebrüder Weiss' && clientname != this.props.clientname) {
            this.props.getContactsOfClient('puContact', 'Gebrüder Weiss');
            this.props.getContactsOfClient('deContact', 'Gebrüder Weiss');
        }

        if (booking && this.props.booking !== booking) {
            const quickPopoverElement = document.getElementsByClassName('quick-quote')[0];
            if (quickPopoverElement) return;
            if (this.state.isSavingBooking) {
                this.setState({ isSavingBooking: false });
                this.toggleShowConfirmModal();
            }
        }

        if (errorMessage && this.props.errorMessage !== errorMessage) {
            this.setState({ isSavingBooking: false });
            this.notify(errorMessage);
        }

        if (isLoadingPUContacts && puContacts !== this.props.puContacts) {
            this.setState({ isLoadingPUContacts: false });
        }

        if (isLoadingDEContacts && deContacts !== this.props.deContacts) {
            this.setState({ isLoadingDEContacts: false });
        }

        if (quickQuoteBookingData !== null){
            console.log({quickQuoteBookingData});
            const client = this.props.dmeClients.find(client => client.pk_id_dme_client === quickQuoteBookingData.booking.customer_id);
            const lines = [];
            quickQuoteBookingData.booking_lines.forEach(_line => {
                const line = {..._line};
                line['pk_booking_lines_id'] = uuid();
                line['packed_status'] = 'original';
                line['lineDetails'] = [];
                if (line['e_dimUOM'] === 'm'){
                    line['e_dimLength'] *= 100;
                    line['e_dimWidth'] *= 100;
                    line['e_dimHeight'] *= 100;
                    line['e_dimUOM'] === 'cm';
                } else if (line['e_dimUOM'] === 'mm'){
                    line['e_dimLength'] *= 0.1;
                    line['e_dimWidth'] *= 0.1;
                    line['e_dimHeight'] *= 0.1;
                    line['e_dimUOM'] === 'cm';
                }
                if (line['e_weightUOM'] === 'gram'){
                    line['e_weightPerEach'] *= 0.001;
                    line['e_weightUOM'] === 'kg';
                }
                lines.push(line);
            });
            this.setState({
                formInputs: {
                    b_client_name: client ? client.company_name : null,
                    pu_Address_State: quickQuoteBookingData.booking.pu_Address_State,
                    pu_Address_PostalCode: quickQuoteBookingData.booking.pu_Address_PostalCode,
                    pu_Address_Suburb: quickQuoteBookingData.booking.pu_Address_Suburb,
                    pu_Address_Type: quickQuoteBookingData.booking.pu_Address_Type,
                    b_booking_tail_lift_pickup: quickQuoteBookingData.booking.b_booking_tail_lift_pickup === '0' ? false : true,
                    de_To_Address_State: quickQuoteBookingData.booking.de_To_Address_State,
                    de_To_Address_PostalCode: quickQuoteBookingData.booking.de_To_Address_PostalCode,
                    de_To_Address_Suburb: quickQuoteBookingData.booking.de_To_Address_Suburb,
                    de_To_AddressType: quickQuoteBookingData.booking.de_To_AddressType,
                    b_booking_tail_lift_deliver: quickQuoteBookingData.booking.b_booking_tail_lift_deliver === '0' ? false : true,
                    insurance_service: quickQuoteBookingData.booking.insurance_service,
                    client_sales_total: quickQuoteBookingData.booking.client_sales_total,
                },
                puSuburb: { label: quickQuoteBookingData.booking.pu_Address_Suburb, value: quickQuoteBookingData.booking.pu_Address_Suburb },
                deToSuburb: { label: quickQuoteBookingData.booking.de_To_Address_Suburb, value: quickQuoteBookingData.booking.de_To_Address_Suburb },
                lines,
                selectedLine: null,
                selectedLineId: null
            });
        }
    }

    notify = (text) => {
        toast(text);
    }

    toggleSimpleLineModal() {
        this.setState(prevState => ({ isShowSimpleLineModal: !prevState.isShowSimpleLineModal }));
    }

    toggleSimpleLineDetailModal() {
        this.setState(prevState => ({ isShowSimpleLineDetailModal: !prevState.isShowSimpleLineDetailModal }));
    }

    toggleShowConfirmModal() {
        this.setState(prevState => ({ isShowConfirmModal: !prevState.isShowConfirmModal }));
    }

    setYalePrimaDEAddr(formInputs) {
        formInputs['deToCompanyName'] = 'Cargo Freight Services (CFS)';
        formInputs['de_To_Address_Street_1'] = '1 Kalingra Rd';
        formInputs['de_To_Address_Street_2'] = 'For Reworx - Yale Prima';
        formInputs['de_To_Address_State'] = 'VIC';
        formInputs['de_To_Address_PostalCode'] = '3012';
        formInputs['de_To_Address_Suburb'] = 'TOTTENHAM';
        formInputs['de_To_Address_Country'] = 'Australia';
        formInputs['de_to_Contact_F_LName'] = 'Sam Tabone';
        formInputs['de_to_Phone_Main'] = '61400551515';
        formInputs['de_Email'] = 'sam@reworx.com.au';
        formInputs['de_To_AddressType'] = 'business';
        formInputs['b_booking_tail_lift_deliver'] = false;
        formInputs['de_to_PickUp_Instructions_Address'] = 'Turn left into the driveway from Kalingra Rd and walk to the office.';

        const deToSuburb = { label: 'TOTTENHAM', value: 'TOTTENHAM' };
        this.setState({ deToSuburb, formInputs });
    }

    handleInputChangeContact = (prefix, src) => {
        const { clientname } = this.props;
        const { formInputs } = this.state;
        const isYP = formInputs['b_client_name'] == 'Yale Prima' || this.props.clientname === 'Yale Prima';

        if (prefix) {
            if (clientname === 'dme' && formInputs.b_client_name) {
                if (isYP && Number.isInteger(Number.parseInt(prefix.trim())))
                    this.props.getContactsWithStoreNo(src, prefix, formInputs.b_client_name);
                else
                    this.props.getContactsWithPrefix(src, prefix, formInputs.b_client_name);
            } else if (clientname === 'dme' && !formInputs.b_client_name) {
                this.notify('Please select client');
                return;
            } else {
                if (isYP && Number.isInteger(Number.parseInt(prefix.trim())))
                    this.props.getContactsWithStoreNo(src, prefix, clientname);
                else
                    this.props.getContactsWithPrefix(src, prefix, clientname);
            }

            if (src === 'puContact')
                this.setState({ puPrefix: prefix, isLoadingPUContacts: true });
            else
                this.setState({ dePrefix: prefix, isLoadingDEContacts: true });
        } else {
            if (clientname === 'Gebrüder Weiss') {
                this.props.getContactsOfClient(src, 'Gebrüder Weiss');
            }
        }
    };

    onDateTimeChange(date, src) {
        const formInputs = this.state.formInputs;
        if (src === 'pu-from') {
            if (date === null){
                delete formInputs['puPickUpAvailFrom_Date'];
                delete formInputs['pu_PickUp_Avail_Time_Hours'];
                delete formInputs['pu_PickUp_Avail_Time_Minutes'];
            } else {
                formInputs['puPickUpAvailFrom_Date'] = moment(date).format('YYYY-MM-DD');
                formInputs['pu_PickUp_Avail_Time_Hours'] = moment(date).hour();
                formInputs['pu_PickUp_Avail_Time_Minutes'] = moment(date).minute();
            }
            this.setState({ formInputs, puFromDT: date });
        } else if (src === 'pu-by') {
            if (date === null){
                delete formInputs['pu_PickUp_By_Date'];
                delete formInputs['pu_PickUp_By_Time_Hours'];
                delete formInputs['pu_PickUp_By_Time_Minutes'];
            } else {
                formInputs['pu_PickUp_By_Date'] = moment(date).format('YYYY-MM-DD');
                formInputs['pu_PickUp_By_Time_Hours'] = moment(date).hour();
                formInputs['pu_PickUp_By_Time_Minutes'] = moment(date).minute();
            }
            this.setState({ formInputs, puByDT: date });
        } else if (src === 'de-from') {
            if (date === null){
                delete formInputs['de_Deliver_From_Date'];
                delete formInputs['de_Deliver_From_Hours'];
                delete formInputs['de_Deliver_From_Minutes'];
            } else {
                formInputs['de_Deliver_From_Date'] = moment(date).format('YYYY-MM-DD');
                formInputs['de_Deliver_From_Hours'] = moment(date).hour();
                formInputs['de_Deliver_From_Minutes'] = moment(date).minute();
            }
            this.setState({ formInputs, deFromDT: date });
        } else if (src === 'de-by') {
            if (date === null){
                delete formInputs['de_Deliver_By_Date'];
                delete formInputs['de_Deliver_By_Hours'];
                delete formInputs['de_Deliver_By_Minutes'];
            } else {
                formInputs['de_Deliver_By_Date'] = moment(date).format('YYYY-MM-DD');
                formInputs['de_Deliver_By_Hours'] = moment(date).hour();
                formInputs['de_Deliver_By_Minutes'] = moment(date).minute();
            }
            this.setState({ formInputs, deByDT: date });
        }
    }

    onHandleInput(e) {
        const { formInputs } = this.state;
        const target = e.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        if (name === 'client_sales_total') {
            formInputs[name] = (value === '' ? null : Number(value));
        } else {
            formInputs[name] = value;
        }

        if (e.target.name === 'has_plain_pallet' && !e.target.checked) {
            formInputs['b_pallet_plain_transfer_to_receiver'] = 0;
        }
        if (e.target.name === 'has_chep_pallet' && !e.target.checked) {
            formInputs['b_pallet_chep_account'] = null;
            formInputs['b_pallet_chep_docket_number'] = null;
            formInputs['b_pallet_chep_exchange_to_carrier'] = 0;
            formInputs['b_pallet_chep_transfer_to_carrier'] = 0;
            formInputs['b_pallet_chep_transfer_to_receiver'] = 0;
        }
        if (e.target.name === 'has_loscam_pallet' && !e.target.checked) {
            formInputs['b_pallet_loscam_account'] = null;
            formInputs['b_pallet_loscam_docket_number'] = null;
            formInputs['b_pallet_loscam_exchange_to_carrier'] = 0;
            formInputs['b_pallet_loscam_transfer_to_carrier'] = 0;
            formInputs['b_pallet_loscam_transfer_to_receiver'] = 0;
        }

        this.setState({ formInputs });
    }

    displayNoOptionsMessage() {
        return;
    }

    _findContact = (contacts, mixedContact) => {
        return contacts.find(contact => {
            let fullContact = `${contact._source.companyName} | ${contact._source['street 1']}`;
            fullContact += ` | ${contact._source.suburb} | ${contact._source.postalCode} | ${contact._source.state}`;
            return fullContact === mixedContact;
        });
    };

    handleChangeContact = (selectedOption, src) => {
        const { formInputs } = this.state;
        const { puContacts, deContacts } = this.props;

        if (src === 'puContact') {
            const contact = this._findContact(puContacts, selectedOption.value);
            formInputs['puCompany'] = contact._source.companyName;
            formInputs['pu_Address_Street_1'] = contact._source['street 1'];
            formInputs['pu_Address_street_2'] = contact._source['street 2'];
            formInputs['pu_Address_State'] = contact._source.state;
            formInputs['pu_Address_PostalCode'] = contact._source.postalCode;
            formInputs['pu_Address_Suburb'] = contact._source.suburb;
            formInputs['pu_Address_Country'] = contact._source.country || 'Australia';
            formInputs['pu_Contact_F_L_Name'] = contact._source.contact;
            formInputs['pu_Phone_Main'] = contact._source.phone;
            formInputs['pu_Email'] = contact._source.email;
            formInputs['pu_Address_Type'] = contact._source.type || 'business';
            const puSuburb = {label: contact._source.suburb, value: contact._source.suburb};
            const puPrefix = {label: selectedOption.value, value: selectedOption.value};
            this.setState({ formInputs, puSuburb, puPrefix });
        } else if (src === 'deContact') {
            const contact = this._findContact(deContacts, selectedOption.value);
            formInputs['deToCompanyName'] = contact._source.companyName;
            formInputs['de_To_Address_Street_1'] = contact._source['street 1'];
            formInputs['de_To_Address_Street_2'] = contact._source['street 2'];
            formInputs['de_To_Address_State'] = contact._source.state;
            formInputs['de_To_Address_PostalCode'] = contact._source.postalCode;
            formInputs['de_To_Address_Suburb'] = contact._source.suburb;
            formInputs['de_To_Address_Country'] = contact._source.country || 'Australia';
            formInputs['de_to_Contact_F_LName'] = contact._source.contact;
            formInputs['de_to_Phone_Main'] = contact._source.phone;
            formInputs['de_Email'] = contact._source.email;
            formInputs['de_To_AddressType'] = contact._source.type || 'business';
            const deToSuburb = {label: contact._source.suburb, value: contact._source.suburb};
            const dePrefix = {label: selectedOption.value, value: selectedOption.value};
            this.setState({ formInputs, deToSuburb, dePrefix });
        }

        this.setState({ formInputs, isBookingModified: true });
    };

    handleInputChangeSuburb = (query, src) => {
        let postalCodePrefix = null;
        let suburbPrefixes = [];
        const iters = query.split(' ');
        iters.map((iter) => {
            if (!isNaN(iter))
                postalCodePrefix = iter;
            else
                suburbPrefixes.push(iter);
        });

        if (postalCodePrefix || suburbPrefixes.length > 0) {
            if (src === 'puSuburb') {
                this.props.getAddressesWithPrefix(
                    'puAddress',
                    join(suburbPrefixes, ' '),
                    postalCodePrefix
                );
            } else if (src === 'deToSuburb') {
                this.props.getAddressesWithPrefix(
                    'deToAddress',
                    join(suburbPrefixes, ' '),
                    postalCodePrefix
                );
            }

            this.setState({ suburbPrefix: join(suburbPrefixes, ' '), postalCodePrefix });
        }
    };

    /*
     * @param {array<object>} addresses - address array from es(elasticsearch)
     * @param {string} mixedAddress - mixed address
     * @return {object} address - found address object
     */
    _findAddress = (addresses, mixedAddress) => {
        return addresses.find(address => {
            const fullAddress = `${address._source.suburb} ${address._source.postal_code} ${address._source.state}`;
            return fullAddress === mixedAddress;
        });
    };

    handleChangeSuburb = (selectedOption, src) => {
        const { formInputs } = this.state;
        const { puAddresses, deToAddresses } = this.props;

        if (src === 'puSuburb') {
            const address = this._findAddress(puAddresses, selectedOption.value);
            formInputs['pu_Address_State'] = address._source.state;
            formInputs['pu_Address_PostalCode'] = address._source.postal_code;
            formInputs['pu_Address_Suburb'] = address._source.suburb;
            formInputs['pu_Address_Country'] = 'Australia';
            const puSuburb = { label: address._source.suburb, value: address._source.suburb };
            this.setState({ puSuburb, formInputs });
        } else if (src === 'deToSuburb') {
            const address = this._findAddress(deToAddresses, selectedOption.value);
            formInputs['de_To_Address_State'] = address._source.state;
            formInputs['de_To_Address_PostalCode'] = address._source.postal_code;
            formInputs['de_To_Address_Suburb'] = address._source.suburb;
            formInputs['de_To_Address_Country'] = 'Australia';
            const deToSuburb = { label: address._source.suburb, value: address._source.suburb };
            this.setState({ deToSuburb, formInputs });
        }
    };

    onClickNewLine = (e) => {
        e.preventDefault();
        this.setState({ selectedLine: null, selectedLineId: null });
        this.toggleSimpleLineModal();
    }

    createBookingLine = (line) => {
        const { lines } = this.state;
        line['pk_booking_lines_id'] = uuid();
        line['packed_status'] = 'original';
        line['lineDetails'] = [];
        lines.push(line);
        this.setState({ lines, selectedLine: null, selectedLineId: null });
    }

    findLineIndex = () => {
        const { lines, selectedLineId } = this.state;
        return lines.findIndex((line) => line.pk_booking_lines_id === selectedLineId);
    }

    updateBookingLine = (line) => {
        const { lines } = this.state;
        lines[this.findLineIndex()] = { ...lines[this.findLineIndex()], ...line };
        this.setState({ lines, selectedLine: null, selectedLineId: null });
    }

    deleteBookingLine = () => {
        const { lines } = this.state;
        lines.splice(this.findLineIndex(), 1);
        this.setState({
            lines,
            selectedLine: null,
            selectedLineId: null
        });
        this.toggleSimpleLineModal();
    }

    onClickRemoveLine = (line) => {
        const { lines } = this.state;
        this.setState({
            lines: lines.filter(_line => _line !== line)
        });
    }

    onClickLine = (line) => {
        this.setState({ selectedLine: line, selectedLineId: line['pk_booking_lines_id'] });
        this.toggleSimpleLineModal();
    }

    onClickNewLineDetail = (e, line) => {
        e.preventDefault();
        this.setState({
            selectedLine: line,
            selectedLineDetail: null,
            selectedLineDetailId: null
        });
        this.toggleSimpleLineDetailModal();
    }

    createBookingLineDetail = (line, lineDetail) => {
        const { lines } = this.state;
        lineDetail['fk_booking_lines_id'] = line.pk_booking_lines_id;
        line.lineDetails.push(lineDetail);
        lines[this.findLineIndex()] = line;
        this.setState({ lines, selectedLine: null, selectedLineId: null });
    }

    updateBookingLineDetail = (line, lineDetail) => {
        const { lines, selectedLineDetailKey } = this.state;
        line.lineDetails[selectedLineDetailKey] = lineDetail;
        lines[this.findLineIndex()] = line;
        this.setState({
            lines,
            selectedLine: null,
            selectedLineId: null,
            selectedLineDetail: null,
            selectedLineDetailKey: null,
        });
    }

    deleteBookingLineDetail = (line) => {
        const { lines, selectedLineDetailKey } = this.state;
        line.lineDetails.splice(selectedLineDetailKey, 1);
        lines[this.findLineIndex()] = line;
        this.setState({
            lines,
            selectedLine: null,
            selectedLineId: null,
            selectedLineDetail: null,
            selectedLineDetailKey: null,
        });
        this.toggleSimpleLineDetailModal();
    }

    onClickRemoveLineDetail = (line, lineDetail) => {
        const { lines } = this.state;
        const edited_lines = lines.map(_line => {
            if (_line !== line) return _line;
            _line.lineDetails = _line.lineDetails.filter(_lineDetail => _lineDetail !== lineDetail);
        });

        this.setState({
            line: edited_lines
        });
    }

    onClickLineDetail = (line, lineDetail, lineDetailKey) => {
        this.setState({
            selectedLine: line,
            selectedLineId: line['pk_booking_lines_id'],
            selectedLineDetail: lineDetail,
            selectedLineDetailKey: lineDetailKey
        });
        this.toggleSimpleLineDetailModal();
    }

    handleChangeSelect = (e, src) => {
        const { formInputs } = this.state;
        const hideCategoryClients = ['Gebrüder Weiss', 'Dioni', 'Tixana Pty Ltd', 'Osmoflo', 'Faresin Australia'];
        const isShowCategory = !hideCategoryClients.includes(e.value);
        formInputs[src] = e.value;
        formInputs['b_booking_Category'] = '';
        if (src == 'b_client_name' && e.value == 'Yale Prima') {
            this.setYalePrimaDEAddr(formInputs);
        }

        this.setState({ formInputs, isShowCategory });
    }
    
    onSubmit = (e) => {
        e.preventDefault();
        const { formInputs, lines  } = this.state;
        const { clientname, clientId, dmeClients } = this.props;
        console.log({formInputs});
        if (formInputs['insurance_service'] && Number(formInputs['client_sales_total']) <= 0) {
            this.notify('Please input value of goods.');
            return;
        }
        
        // Initialize validation errors object
        let validationErrors = {};

        // Required fields validation
        const requiredFields = [
            {
                field_name: 'puCompany',
                field: 'Pickup Company'
            },
            {
                field_name: 'pu_Address_Street_1',
                field: 'Pickup Street 1'
            },
            {
                field_name: 'pu_Address_Country',
                field: 'Pickup Country'
            },
            {
                field_name: 'pu_Address_Suburb',
                field: 'Pickup Suburb'
            },
            {
                field_name: 'pu_Address_PostalCode',
                field: 'Pickup Postal Code'
            },
            {
                field_name: 'pu_Address_State',
                field: 'Pickup State'
            },
            {
                field_name: 'pu_Contact_F_L_Name',
                field: 'Pickup Contact'
            },
            {
                field_name: 'pu_Phone_Main',
                field: 'Pickup Phone'
            },
            {
                field_name: 'pu_Email',
                field: 'Pickup Email'
            },            
            {
                field_name: 'deToCompanyName',
                field: 'Delivery Company'
            },
            {
                field_name: 'de_To_Address_Street_1',
                field: 'Delivery Street 1'
            },
            {
                field_name: 'de_To_Address_Country',
                field: 'Delivery Country'
            },
            {
                field_name: 'de_To_Address_Suburb',
                field: 'Delivery Suburb'
            },
            {
                field_name: 'de_To_Address_PostalCode',
                field: 'Delivery Postal Code'
            },
            {
                field_name: 'de_To_Address_State',
                field: 'Delivery State'
            },
            {
                field_name: 'de_to_Contact_F_LName',
                field: 'Delivery Contact'
            },
            {
                field_name: 'de_to_Phone_Main',
                field: 'Delivery Phone'
            },
            {
                field_name: 'de_Email',
                field: 'Delivery Email'
            }
        ];

        if(isGWSubClient(formInputs['b_client_name'])) {
            requiredFields.push(...[
                {
                    field_name: 'pu_Address_Type',
                    field: 'Pickup Address Type'
                },
                {
                    field_name: 'de_To_AddressType',
                    field: 'Delivery Address Type'
                }
            ]);
        }

        let isFilled = true;
        for (let requiredField of requiredFields) {
            if (isEmpty(formInputs[requiredField.field_name])) {
                validationErrors[requiredField.field_name] = `${requiredField.field} is required`;
                isFilled = false;
            }
        }

        // Client validation
        if (clientname === 'dme' && !formInputs['b_client_name']) {
            validationErrors['b_client_name'] = 'Please select client';
            isFilled = false;
        }

        if (!isFilled) {
            this.setState({ validationErrors });
            return;
        }


        // Date/Time validations
        if (isEmpty(formInputs['puPickUpAvailFrom_Date']) || formInputs['puPickUpAvailFrom_Date'] === 'Invalid date') {
            validationErrors['puPickUpAvailFrom_Date'] = 'Pickup From Date is required';
        }

        // Phone number validations  
        if (!isValidPhoneNumber(formInputs['pu_Phone_Main'])) {
            validationErrors['pu_Phone_Main'] = 'Please enter a valid phone number';
        }

        if (!isValidPhoneNumber(formInputs['de_to_Phone_Main'])) {
            validationErrors['de_to_Phone_Main'] = 'Please enter a valid phone number';
        }

        // Email validations
        if (!validateEmail(formInputs['pu_Email'])) {
            validationErrors['pu_Email'] = 'Please enter a valid email address';
        }

        if (!validateEmail(formInputs['de_Email'])) {
            validationErrors['de_Email'] = 'Please enter a valid email address';
        }

        // Validate Dates

        if (!formInputs['de_Deliver_From_Date'] && formInputs['de_Deliver_From_Hours']) {
            validationErrors['de_Deliver_From_Date'] = 'Please set Delivery From date.';
        }

        if (formInputs['puPickUpAvailFrom_Date'] && formInputs['pu_PickUp_By_Date']) {
            if (formInputs['pu_PickUp_By_Date'] < formInputs['puPickUpAvailFrom_Date']) {
                validationErrors['pu_PickUp_By_Date'] = 'Pickup By Date should be after Pickup From Date';
            } else if (formInputs['pu_PickUp_By_Date'] === formInputs['puPickUpAvailFrom_Date']) {
                if (parseInt(formInputs['pu_PickUp_By_Time_Hours']) < parseInt(formInputs['pu_PickUp_Avail_Time_Hours'])) {
                    validationErrors['pu_PickUp_By_Time_Hours'] = 'Pickup By time should be after Pickup From time';
                }
            }
        }

        if(moment(`${formInputs['puPickUpAvailFrom_Date']} ${formInputs['pu_PickUp_Avail_Time_Hours']}:${formInputs['pu_PickUp_Avail_Time_Minutes']}`,'YYYY-MM-DD H:m') < moment()){
            validationErrors['puPickUpAvailFrom_Date'] = 'Pickup From date must be in the future.';
        }

        if (formInputs['de_Deliver_By_Date'] && formInputs['de_Deliver_From_Date']) {
            if (formInputs['de_Deliver_By_Date'] < formInputs['de_Deliver_From_Date']) {
                validationErrors['de_Deliver_By_Date'] = 'Delivery By date should be past than Delivery From date';
            } else if (formInputs['de_Deliver_By_Date'] == formInputs['de_Deliver_From_Date']) {
                if (parseInt(formInputs['de_Deliver_By_Hours']) < parseInt(formInputs['de_Deliver_From_Hours'])) {
                    validationErrors['de_Deliver_By_Date'] = 'Delivery By date should be past than Delivery From date';
                }
            }
        }

        if (moment(`${formInputs['de_Deliver_From_Date']} ${formInputs['de_Deliver_From_Hours']}:${formInputs['de_Deliver_From_Minutes']}`,'YYYY-MM-DD H:m') < moment()){
            validationErrors['de_Deliver_From_Date'] = 'Delivery From date must be in the future.';
        }

        if (formInputs['de_Deliver_From_Date'] || formInputs['de_Deliver_By_Date']) {
            if ((formInputs['pu_PickUp_By_Date'] || formInputs['puPickUpAvailFrom_Date']) >
                (formInputs['de_Deliver_From_Date'] || formInputs['de_Deliver_By_Date'])) {
                validationErrors['de_Deliver_From_Date'] = 'Delivery date should be past than Pickup date';
            } else if ((formInputs['pu_PickUp_By_Date'] || formInputs['puPickUpAvailFrom_Date']) ==
                (formInputs['de_Deliver_From_Date'] || formInputs['de_Deliver_By_Date'])) {
                if ((formInputs['pu_PickUp_Avail_Time_Hours'] || formInputs['pu_PickUp_By_Time_Hours']) <
                    (formInputs['de_Deliver_From_Hours'] || formInputs['de_Deliver_By_Hours'])) {
                    validationErrors['de_Deliver_From_Date'] = 'Delivery date should be past than Pickup date';
                }
            }
        }

        // Check lines
        if (lines.length === 0) {
            validationErrors['lines'] = 'Please add items';
        } else {
            const isAW = formInputs['b_client_name'] == 'Ariston Building & Rural' || clientname == 'Ariston Building & Rural';

            if (!(isGWSubClient(formInputs['b_client_name']) || isAW)) {
                let noContentLinesCnt = 0;
                lines.map((line) => {
                    if (line['lineDetails'].length === 0) {
                        noContentLinesCnt += 1;
                    }
                });

                if (noContentLinesCnt > 0) {
                    validationErrors['lines'] = `${noContentLinesCnt} Lines don't have content details`;
                }
            }
        }

        // If there are any validation errors, update state and return
        if (Object.keys(validationErrors).length > 0) {
            this.setState({ validationErrors });
            // console.log(validationErrors);
            return;
        }

        // Set client info
        if (clientname !== 'dme') {
            formInputs['b_client_name'] = clientname;
            formInputs['kf_client_id'] = clientId;
        } else {
            const client = dmeClients.find(client => client.company_name === formInputs['b_client_name']);
            formInputs['kf_client_id'] = client.dme_account_num;
        }

        formInputs['pu_Address_Type'] = formInputs['pu_Address_Type'] || 'business';
        formInputs['de_To_AddressType'] = formInputs['de_To_AddressType'] || 'business';
        formInputs['b_status'] = 'Entered';
        formInputs['b_booking_Category'] = 'Pre Booking';
        this.props.saveBooking(formInputs, lines);
        this.setState({ isSavingBooking: true, formInputs });
    }

    onClickConfirmBtn = () => {
        const { formInputs } = this.state;
        const isYP = formInputs['b_client_name'] == 'Yale Prima' || this.props.clientname === 'Yale Prima';

        this.setState({
            formInputs: {},
            puPrefix: '', dePrefix: '',
            puFromDT: null, puByDT: null,
            deFromDT: null, deByDT: null,
            puSuburb: { value: '' }, deToSuburb: { value: '' },
            lines: []
        });

        if (isYP) {
            this.setYalePrimaDEAddr({ 'b_client_name': 'Yale Prima' });
        }

        this.toggleShowConfirmModal();
    }

    resetForm = () => {
        this.setState({
            formInputs: {},
            puPrefix: '', dePrefix: '',
            puFromDT: null, puByDT: null,
            deFromDT: null, deByDT: null,
            puSuburb: { value: '' }, deToSuburb: { value: '' },
            lines: []
        });
    }

    onClickCancelBtn = () => {
        const { booking } = this.props;
        this.toggleShowConfirmModal();
        window.open('/booking?bookingId=' + booking.b_bookingID_Visual, '_blank');
        window.focus();
    }

    onClickNewAddressBtn = (e, src) => {
        const { formInputs } = this.state;
        e.preventDefault();

        if (src == 'pu') {
            formInputs['puCompany'] = '';
            formInputs['pu_Address_Street_1'] = '';
            formInputs['pu_Address_street_2'] = '';
            formInputs['pu_Address_State'] = '';
            formInputs['pu_Address_PostalCode'] = '';
            formInputs['pu_Address_Suburb'] = '';
            formInputs['pu_Address_Country'] = '';
            formInputs['pu_Contact_F_L_Name'] = '';
            formInputs['pu_Phone_Main'] = '';
            formInputs['pu_Email'] = '';
            formInputs['pu_Address_Type'] = '';
            this.setState({ formInputs, puSuburb: { value: '' }, puPrefix: '' });
        } else if (src == 'de') {
            formInputs['deToCompanyName'] = '';
            formInputs['de_To_Address_Street_1'] = '';
            formInputs['de_To_Address_Street_2'] = '';
            formInputs['de_To_Address_State'] = '';
            formInputs['de_To_Address_PostalCode'] = '';
            formInputs['de_To_Address_Suburb'] = '';
            formInputs['de_To_Address_Country'] = '';
            formInputs['de_to_Contact_F_LName'] = '';
            formInputs['de_to_Phone_Main'] = '';
            formInputs['de_Email'] = '';
            formInputs['de_To_AddressType'] = '';
            this.setState({ formInputs, deToSuburb: { value: '' }, dePrefix: '' });
        }
    }

    render() {
        const {
            packageTypes, dmeClients, puContacts, deContacts, puAddresses, deToAddresses, clientname
        } = this.props;
        const {
            puPrefix, dePrefix, formInputs, isShowSimpleLineModal, lines, selectedLine,
            isShowSimpleLineDetailModal, selectedLineDetail, isLoadingPUContacts, isLoadingDEContacts,
            puSuburb, deToSuburb, puFromDT, puByDT, deFromDT, deByDT, validationErrors, isShowCategory
        } = this.state;
        const isYP = clientname == 'Yale Prima' || formInputs['b_client_name'] == 'Yale Prima';
        const isAP = clientname == 'Anchor Packaging Pty Ltd' || formInputs['b_client_name'] == 'Anchor Packaging Pty Ltd';
        
        // Populate puAddresses and deToAddresses
        let puAddressOptions = [];
        let deToAddressOptions = [];
        if (formInputs['pu_Address_Suburb'] && puAddresses.length === 0) {
            const value = `${formInputs['pu_Address_Suburb']}`;
            puAddressOptions = [{ value: value, label: value }];
        } else if (puAddresses.length > 0) {
            puAddressOptions = sortByPostalCodeAndSuburb(puAddresses).map(address => {
                const value = `${address._source.suburb} ${address._source.postal_code} ${address._source.state}`;
                return { value: value, label: value };
            });
        }
        if (formInputs['de_To_Address_Suburb'] && deToAddresses.length === 0) {
            const value = `${formInputs['de_To_Address_Suburb']}`;
            deToAddressOptions = [{ value: value, label: value }];
        } else if (deToAddresses.length > 0) {
            deToAddressOptions = sortByPostalCodeAndSuburb(deToAddresses).map(address => {
                const value = `${address._source.suburb} ${address._source.postal_code} ${address._source.state}`;
                return { value: value, label: value };
            });
        }

        // Populate puContacts and deContacts
        let puContactOptions = [];
        let deContactOptions = [];
        if (puPrefix && puContacts.length === 0) {
            puContactOptions = [{ value: puPrefix, label: puPrefix }];
        } else if (puContacts.length > 0) {
            puContactOptions = puContacts.map(contact => {
                let value = `${contact._source.companyName} | ${contact._source['street 1']}`;
                value += ` | ${contact._source.suburb} | ${contact._source.postalCode} | ${contact._source.state}`;
                return { value: value, label: value };
            });
        }
        if (dePrefix && deContacts.length === 0) {
            deContactOptions = [{ value: dePrefix, label: dePrefix }];
        } else if (deContacts.length > 0) {
            deContactOptions = deContacts.map(contact => {
                let value = `${contact._source.companyName} | ${contact._source['street 1']}`;
                value += ` | ${contact._source.suburb} | ${contact._source.postalCode} | ${contact._source.state}`;
                return { value: value, label: value };
            });
        }
        
        const clientnameOptions = dmeClients
            .map(client => ({ value: client.company_name, label: client.company_name }));
        const currentClientnameOption = { value: formInputs['b_client_name'], label: formInputs['b_client_name'] };

        const renderedLines = lines.map((line, key) => {
            const renderedlineDetails = (line.lineDetails || []).map((lineDetail, lineDetailKey) => {
                return (
                    <div className="row content-detail" key={lineDetailKey}>
                        <div
                            className={isYP ? 'col-md-2 rect2' : 'col-md-1 rect2'}
                        >
                            <div>{lineDetail.quantity}</div>
                        </div>
                        <div
                            className={isYP ? 'col-md-4 rect2' : 'col-md-2 rect2'}
                        >
                            <div>{lineDetail.clientRefNumber}</div>
                        </div>
                        <div
                            className={isYP ? 'none col-md-2 rect2' : 'col-md-2 rect2'}
                        >
                            <div>{lineDetail.gap_ra}</div>
                        </div>
                        <div
                            className={isYP ? 'col-md-4 rect2' : 'col-md-2 rect2'}
                        >
                            <div>{lineDetail.modelNumber}</div>
                        </div>
                        <div
                            className={isYP ? 'none col-md-2 rect2' : 'col-md-2 rect2'}
                        >
                            <div>{lineDetail.itemDescription}</div>
                        </div>
                        <div
                            className={isYP ? 'none col-md-2 rect2' : 'col-md-2 rect2'}
                        >
                            <div>{lineDetail.itemFaultDescription}</div>
                        </div>
                        <div
                            className={isYP ? 'none col-md-2 rect2' : 'col-md-1 rect2'}
                        >
                            <div
                                className='btn btn-icon btn-icon-xs m-0'
                                onClick={() => this.onClickLineDetail(line, lineDetail, lineDetailKey)}
                            >
                                <i className='fa fa-edit'></i>
                            </div>
                            <div
                                className='btn btn-icon btn-icon-xs m-0 text-danger'
                                onClick={() => this.onClickRemoveLineDetail(line, lineDetail, lineDetailKey)}
                            >
                                <i className='fa fa-trash'></i>
                            </div>
                        </div>
                    </div>
                );
            });

            return (
                <tr key={`line-${key}`}>
                    <td>
                        <div className='flex justify-center'>
                            <div
                                className='btn btn-icon btn-icon-xs p-0'
                                onClick={() => this.onClickLine(line)}
                            >
                                <i className='fa fa-edit'></i>
                            </div>
                            <div
                                className='btn btn-icon btn-icon-xs text-danger p-0'
                                onClick={() => this.onClickRemoveLine(line)}
                            >
                                <i className='fa fa-trash'></i>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div>{line.e_type_of_packaging}</div>
                    </td>
                    <td>
                        <div>{line.e_qty}</div>
                    </td>
                    <td>
                        <div>{line.e_dimLength}</div>
                    </td>
                    <td>
                        <div>{line.e_dimWidth}</div>
                    </td>
                    <td>
                        <div>{line.e_dimHeight}</div>
                    </td>
                    <td>
                        <div>{line.e_weightPerEach}</div>
                    </td>
                    <td>
                        {renderedlineDetails}
                        <div className="row content-detail new-line-detail flex justify-end items-center p-2" onClick={(e) => this.onClickNewLineDetail(e, line)}>
                            <div className='btn btn-primary'><i className="icon icon-plus"></i> Add Content Details</div>
                        </div>
                    </td>
                </tr>
            );
        });

        // Helper function to get input class based on validation
        const getInputClass = (fieldName) => {
            const isSelectField = [
                'b_client_name',
                'pu_Address_Suburb',
                'de_To_Address_Suburb'
            ].includes(fieldName);

            const baseClass = isSelectField ? 'select' : 'form-control';
            const hasValue = formInputs[fieldName] && formInputs[fieldName].trim() !== '';
            const hasError = validationErrors[fieldName];

            if (hasValue) {
                return baseClass;
            }

            if (hasError) {
                return `${baseClass} is-invalid`;
            }

            return `${baseClass} required`;
        };

        // Helper function to render validation error message
        const renderError = (fieldName) => {
            if (validationErrors[fieldName]) {
                return <div className="invalid-feedback d-block">{validationErrors[fieldName]}</div>;
            }
            return null;
        };

        return (
            <div className='create-a-booking-page'>
                <LoadingOverlay
                    active={this.state.isSavingBooking}
                    spinner
                    text='Saving...'
                >
                    <form onSubmit={(e) => this.onSubmit(e)} role="form" id="booking-form">
                        <div className='panel'>
                            <div className='flex panel-header justify-center mt-3 mb-3'>
                                <h3 className='font-bold text-gradient'>
                                    Booking Information
                                </h3>
                            </div>
                            <div className='flex flex-col grow'>
                                <label className='form-label'>Client Name: <span className='required'/></label>
                                <div className='px-3'>
                                    {clientname === 'dme' ? (
                                        <React.Fragment>
                                            <Select
                                                className={getInputClass('b_client_name')}
                                                value={currentClientnameOption}
                                                onChange={(e) => this.handleChangeSelect(e, 'b_client_name')}
                                                options={clientnameOptions}
                                                placeholder='Select client'
                                                noOptionsMessage={() => this.displayNoOptionsMessage()}
                                            />
                                            {renderError('b_client_name')}
                                        </React.Fragment>
                                    ) : (
                                        <input 
                                            className='form-control item-center d-flex font-bold' 
                                            value={clientname} 
                                            disabled 
                                        />
                                    )} 
                                </div>
                            </div>
                            <div className='flex'>
                                <div className='flex flex-col flex-1'>
                                    <label className='form-label'>Sales Order:</label>
                                    <div className='px-3'>
                                        <input 
                                            placeholder="Enter sales order number"
                                            name="b_client_order_num"
                                            type="text"
                                            value={formInputs['b_client_order_num'] ? formInputs['b_client_order_num'] : ''} 
                                            className="form-control"
                                            onChange={(e) => this.onHandleInput(e)}
                                        />
                                    </div>
                                </div>
                                <div className='flex flex-col flex-1'>
                                    <label className='form-label'>Invoice No:</label>
                                    <div className='px-3'>
                                        <input 
                                            placeholder="Enter invoice number"
                                            name="b_client_sales_inv_num"
                                            type="text"
                                            value={formInputs['b_client_sales_inv_num'] ? formInputs['b_client_sales_inv_num'] : ''} 
                                            className="form-control"
                                            onChange={(e) => this.onHandleInput(e)}
                                        />
                                    </div>
                                </div>
                                { isShowCategory && (
                                    <div className='flex flex-col flex-1'>
                                        <label className='form-label'>Category:</label>
                                        <div className='px-3'>
                                            <select
                                                className='form-control'
                                                name="b_booking_Category"
                                                value={formInputs['b_booking_Category'] ? formInputs['b_booking_Category'] : ''}
                                                onChange={(e) => this.onHandleInput(e)}
                                            >
                                                <option value="" defaultValue="" disabled hidden>Select category</option>
                                                {BOOKING_CATEGORIES.map(category => <option value={category} key={category}>{category}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                )}
                                <div className='flex flex-col flex-1 hidden'>
                                    <label className='form-label'>Priority:</label>
                                    <div className='px-3'>
                                        <select
                                            className='form-control'
                                            name="b_booking_Priority"
                                            value={formInputs['b_booking_Priority'] ? formInputs['b_booking_Priority'] : ''}
                                            onChange={(e) => this.onHandleInput(e)}
                                        >
                                            <option value="" defaultValue="" disabled hidden>Select priority</option>
                                            {BOOKING_PRIORITIES.map(priority => <option value={priority} key={priority}>{priority}</option>)}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            {
                                !isGWSubClient(formInputs['b_client_name']) && 
                                (<div className="flex justify-start">
                                    <div className='px-3 py-2 flex justify-content-center align-items-center'>
                                        <label className='form-label'>Insurance Service: </label>
                                        <input
                                            className='form-control my-0'
                                            name='insurance_service'
                                            checked={formInputs['insurance_service']}
                                            onChange={(e) => this.onHandleInput(e)}
                                            type='checkbox'
                                        />
                                    </div>
                                    <div className='px-3 py-2 flex justify-content-center align-items-center'>
                                        <label className='form-label value-of-goods w-200px'>Value of Goods: {formInputs['insurance_service'] && <span className='required'/>}</label>
                                        <input
                                            className='form-control my-0'
                                            name='client_sales_total'
                                            value={formInputs['client_sales_total']}
                                            type='number'
                                            step="0.1"
                                            min={500}
                                            onChange={(e) => this.onHandleInput(e)}
                                            required={formInputs['insurance_service']}
                                        />
                                    </div>
                                </div>)
                            }
                        </div>
                        <hr/>
                        <div className='panel'>
                            <div className='flex panel-header justify-center mt-3 mb-3'>
                                <h3 className='font-bold text-gradient'>
                                    Where are you sending from?
                                </h3>
                            </div>
                            <div className='flex flex-col'>
                                <div className='flex flex-col mb-3'>
                                    <label className='form-label'>Where are you sending from?</label>
                                    <div className='flex flex-row'>
                                        <div className='grow px-3'>
                                            <LoadingOverlay
                                                active={isLoadingPUContacts}
                                                spinner
                                                text=''
                                            >
                                                <Select
                                                    className="select"
                                                    value={puPrefix}
                                                    onChange={(e) => this.handleChangeContact(e, 'puContact')}
                                                    onInputChange={debounce((e) => this.handleInputChangeContact(e, 'puContact'), 500)}
                                                    options={puContactOptions}
                                                    placeholder='Find address'
                                                    openMenuOnClick = {true}
                                                    noOptionsMessage={() => this.displayNoOptionsMessage()}
                                                    filterOption={(options) => {return options;}}
                                                />
                                            </LoadingOverlay>
                                        </div>
                                        <div className='px-3'>
                                            <Button
                                                color="primary"
                                                onClick={(e) => this.onClickNewAddressBtn(e, 'pu')}
                                            >
                                                <i className="icon icon-plus"></i> New Address
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                                <div className='flex flex-col w-half'>
                                    <label className='form-label'>Company: <span className='required'/></label>
                                    <div className='mx-3'>
                                        <input 
                                            placeholder="Business Name / Contact Name"
                                            name="puCompany"
                                            type="text"
                                            value={formInputs['puCompany'] ? formInputs['puCompany'] : ''} 
                                            className={getInputClass('puCompany')}
                                            onChange={(e) => this.onHandleInput(e)}
                                            maxLength='29'
                                        />
                                        {renderError('puCompany')}
                                    </div>
                                </div>
                                <div className='flex flex-row'>
                                    <div className='flex flex-col grow'>
                                        <label className='form-label'>Street 1: <span className='required'/></label>
                                        <div className='px-3'>
                                            <input 
                                                placeholder="Street name and number"
                                                name="pu_Address_Street_1"
                                                type="text"
                                                value={formInputs['pu_Address_Street_1'] ? formInputs['pu_Address_Street_1'] : ''} 
                                                className={getInputClass('pu_Address_Street_1')}
                                                onChange={(e) => this.onHandleInput(e)}
                                                maxLength='29'
                                            />
                                            {renderError('pu_Address_Street_1')}
                                        </div>
                                    </div>
                                    <div className='flex flex-col grow'>
                                        <label className='form-label'>Street 2:</label>
                                        <div className='px-3'>
                                            <input 
                                                placeholder="Delivery location for the driver (ie: Front Desk, Warehouse, Back Dock)"
                                                name="pu_Address_street_2"
                                                type="text"
                                                value={formInputs['pu_Address_street_2'] ? formInputs['pu_Address_street_2'] : ''} 
                                                className={getInputClass('pu_Address_street_2')}
                                                onChange={(e) => this.onHandleInput(e)}
                                                maxLength='29'
                                            />
                                            {renderError('pu_Address_street_2')}
                                        </div>
                                    </div>
                                </div>
                                
                                <div className='flex flex-row'>
                                    <div className='flex flex-col w-quarter'>
                                        <label className='form-label'>Country: <span className='required'/></label>
                                        <div className='px-3'>
                                            <input 
                                                placeholder="Input Country"
                                                name="pu_Address_Country"
                                                type="text"
                                                value={formInputs['pu_Address_Country'] ? formInputs['pu_Address_Country'] : ''} 
                                                className={getInputClass('pu_Address_Country')}
                                                onChange={(e) => this.onHandleInput(e)}
                                                maxLength='29'
                                            />
                                            {renderError('pu_Address_Country')}
                                        </div>
                                    </div>
                                    <div className='flex flex-col w-quarter'>
                                        <label className='form-label'>Suburb: <span className='required'/></label>
                                        <div className='grow px-3'>
                                            <Select
                                                className={getInputClass('pu_Address_Suburb')}
                                                value={puSuburb}
                                                onChange={(e) => this.handleChangeSuburb(e, 'puSuburb')}
                                                onInputChange={debounce((e) => this.handleInputChangeSuburb(e, 'puSuburb'), 500)}
                                                options={puAddressOptions}
                                                placeholder='Input suburb'
                                                noOptionsMessage={() => this.displayNoOptionsMessage()}
                                                filterOption={(options) => options}
                                            />
                                            {renderError('pu_Address_Suburb')}
                                        </div>
                                    </div>
                                    <div className='flex flex-col w-quarter'>
                                        <label className='form-label'>Postal Code: <span className='required'/></label>
                                        <div className='px-3'>
                                            <input 
                                                placeholder="Input postal code"
                                                name="pu_Address_PostalCode"
                                                type="text"
                                                value={formInputs['pu_Address_PostalCode'] ? formInputs['pu_Address_PostalCode'] : ''} 
                                                className="form-control"
                                                onChange={(e) => this.onHandleInput(e)}
                                                maxLength='4'
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className='flex flex-col w-quarter'>
                                        <label className='form-label'>State: <span className='required'/></label>
                                        <div className='px-3'>
                                            <select
                                                className='form-control px-3'
                                                name="pu_Address_State"
                                                value={formInputs['pu_Address_State']}
                                                onChange={(e) => this.onHandleInput(e)}
                                                disabled
                                            >
                                                <option value="" defaultValue="" disabled hidden>--- Please select state ---</option>
                                                <option value="NSW">NSW</option>
                                                <option value="NT">NT</option>
                                                <option value="QLD">QLD</option>
                                                <option value="SA">SA</option>
                                                <option value="VIC">VIC</option>
                                                <option value="ACT">ACT</option>
                                                <option value="WA">WA</option>
                                                <option value="TAS">TAS</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className='flex flex-row'>
                                    <div className='flex flex-col w-quarter'>
                                        <label className='form-label'>Contact Name: <span className='required'/></label>
                                        <div className='px-3'>
                                            <input 
                                                placeholder="Input contact name"
                                                name="pu_Contact_F_L_Name"
                                                type="text"
                                                value={formInputs['pu_Contact_F_L_Name'] ? formInputs['pu_Contact_F_L_Name'] : ''} 
                                                className={getInputClass('pu_Contact_F_L_Name')}
                                                onChange={(e) => this.onHandleInput(e)}
                                                maxLength='19'
                                            />
                                            {renderError('pu_Contact_F_L_Name')}
                                        </div>
                                    </div>
                                    <div className='flex flex-col w-quarter'>
                                        <label className='form-label'>Phone: <span className='required'/></label>
                                        <div className='px-3'>
                                            <input 
                                                placeholder="Input phone number"
                                                name="pu_Phone_Main"
                                                type="text"
                                                value={formInputs['pu_Phone_Main'] ? formInputs['pu_Phone_Main'] : ''} 
                                                className={getInputClass('pu_Phone_Main')}
                                                onChange={(e) => this.onHandleInput(e)}
                                                maxLength={15}
                                                minLength={7}
                                            />
                                            {renderError('pu_Phone_Main')}
                                        </div>
                                    </div>
                                    <div className='flex flex-col w-quarter'>
                                        <label className='form-label'>Email: <span className='required'/></label>
                                        <div className='px-3'>
                                            <input 
                                                placeholder="Input Email"
                                                name="pu_Email"
                                                type="text"
                                                value={formInputs['pu_Email'] ? formInputs['pu_Email'] : ''} 
                                                className={getInputClass('pu_Email')}
                                                onChange={(e) => this.onHandleInput(e)}
                                                maxLength='64'
                                            />
                                            {renderError('pu_Email')}
                                        </div>
                                    </div>
                                    <div className='flex flex-col w-quarter'>
                                        <label className='form-label'>Address Type: <span className='required'/></label>
                                        <div className='px-3'>
                                            <select
                                                className={getInputClass('pu_Address_Type')}
                                                name="pu_Address_Type"
                                                value={formInputs['pu_Address_Type']}
                                                onChange={(e) => this.onHandleInput(e)}
                                            >
                                                <option value="" defaultValue="" disabled hidden>--- Please select option ---</option>
                                                <option value="business">Business</option>
                                                <option value="residential">Residential</option>
                                            </select>
                                            {renderError('pu_Address_Type')}
                                        </div>
                                    </div>
                                </div>
                                <div className='flex flex-col'>
                                    <label className='form-label'>Collection Special Instruction:</label>
                                    <div className='px-3'>
                                        <input 
                                            placeholder=""
                                            name="pu_pickup_instructions_address"
                                            type="text"
                                            value={formInputs['pu_pickup_instructions_address'] ? formInputs['pu_pickup_instructions_address'] : ''} 
                                            className={getInputClass('pu_pickup_instructions_address')}
                                            onChange={(e) => this.onHandleInput(e)}
                                            maxLength='29'
                                        />
                                        {renderError('pu_pickup_instructions_address')}
                                    </div>
                                </div>
                                <div className='flex flex-row'>
                                    <div className='mx-3 tail-lift flex p-2'>
                                        <div className='px-3 py-2'>
                                            <input
                                                name="b_booking_tail_lift_pickup"
                                                type="checkbox"
                                                data-method="Email"
                                                checked={formInputs['b_booking_tail_lift_pickup'] ? 'checked' : ''}
                                                onChange={(e) => this.onHandleInput(e)}
                                            />
                                        </div>
                                        <label className='form-label'>Tail Lift Required</label>
                                    </div>
                                </div>
                                <div className='flex flex-row mb-3'>
                                    {/* <div className='flex flex-col w-half'>
                                        <label className='form-label'>Pickup From Date/Time:  <span className='required'/></label>
                                        <div className='px-3'>
                                            <DatePicker
                                                id="puPickUpAvailFrom_Date"
                                                selected={puFromDT}
                                                onChange={(date) => this.onDateTimeChange(date, 'pu-from')}
                                                dateFormat="dd MMM yyyy h:mm aa"
                                                showTimeSelect
                                                minDate={now}
                                            />
                                        </div>
                                    </div> */}
                                    <div className='flex flex-col w-half'>
                                        <label className='form-label'>Pickup From Date/Time:  <span className='required'/></label>
                                        <div className='px-3'>
                                            <DmeDateTimePicker
                                                className={getInputClass('puPickUpAvailFrom_Date')}
                                                selected={puFromDT}
                                                onChange={(date) => this.onDateTimeChange(date, 'pu-from')}
                                                selectPastDates={false}
                                            />
                                            {renderError('puPickUpAvailFrom_Date')}
                                        </div>
                                    </div>
                                    <div className='flex flex-col w-half'>
                                        <label className='form-label'>Pickup By Date/Time:</label>
                                        <div className='px-3'>
                                            <DmeDateTimePicker
                                                className="form-control"
                                                selected={puByDT}
                                                onChange={(date) => this.onDateTimeChange(date, 'pu-by')}
                                                selectPastDates={false}
                                            />
                                        </div>
                                    </div>
                                    {/* <div className='flex flex-col w-half'>
                                        <label className='form-label'>Pickup By Date/Time:</label>
                                        <div className='px-3'>
                                            <DatePicker
                                                id="pu_PickUp_By_Date"
                                                selected={puByDT}
                                                onChange={(date) => this.onDateTimeChange(date, 'pu-by')}
                                                dateFormat="dd MMM yyyy h:mm aa"
                                                showTimeSelect
                                                minDate={now}
                                            />
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                        <hr className={isYP ? 'none' : ''} />
                        <div className={isYP ? 'none' : 'panel'}>
                            <div className='flex panel-header justify-center mt-3 mb-3'>
                                <h3 className='font-bold text-gradient'>
                                    Where are you sending to?
                                </h3>
                            </div>
                            <div className="flex flex-col mb-3">
                                <label className='form-label'>Where are you sending to?</label>
                                <div className='flex flex-row'>
                                    <div className='grow px-3'>
                                        <LoadingOverlay
                                            active={isLoadingDEContacts}
                                            spinner
                                            text=''
                                        >
                                            <Select
                                                className="select"
                                                value={dePrefix}
                                                onChange={(e) => this.handleChangeContact(e, 'deContact')}
                                                onInputChange={debounce((e) => this.handleInputChangeContact(e, 'deContact'), 500)}
                                                options={deContactOptions}
                                                placeholder='Find address'
                                                openMenuOnClick = {true}
                                                noOptionsMessage={() => this.displayNoOptionsMessage()}
                                                filterOption={(options) => {return options;}}
                                                isDisabled={isYP}
                                            />
                                        </LoadingOverlay>
                                    </div>
                                    <div className='px-3'>
                                        <Button
                                            color="primary"
                                            onClick={(e) => this.onClickNewAddressBtn(e, 'de')}
                                            disabled={isYP}
                                        >
                                            <i className="icon icon-plus"></i> New Address
                                        </Button>
                                    </div>
                                </div>
                            </div>
                            <div className='flex flex-row'>
                                <div className='flex flex-col w-half'>
                                    <label className='form-label'>Company: <span className='required'/></label>
                                    <div className='px-3'>
                                        <input 
                                            placeholder="Business Name / Contact Name"
                                            name="deToCompanyName"
                                            type="text"
                                            value={formInputs['deToCompanyName'] ? formInputs['deToCompanyName'] : ''} 
                                            className={getInputClass('deToCompanyName')}
                                            onChange={(e) => this.onHandleInput(e)}
                                            disabled={isYP}
                                            maxLength='29'
                                        />
                                        {renderError('deToCompanyName')}
                                    </div>
                                </div>
                            </div>
                            <div className='flex flex-row'>
                                <div className='flex flex-col w-half'>
                                    <label className='form-label'>Street 1: <span className='required'/></label>
                                    <div className='px-3'>
                                        <input 
                                            placeholder="Street name and number"
                                            name="de_To_Address_Street_1"
                                            type="text"
                                            value={formInputs['de_To_Address_Street_1'] ? formInputs['de_To_Address_Street_1'] : ''} 
                                            className={getInputClass('de_To_Address_Street_1')}
                                            onChange={(e) => this.onHandleInput(e)}
                                            disabled={isYP}
                                            maxLength='29'
                                        />
                                        {renderError('de_To_Address_Street_1')}
                                    </div>
                                </div>
                                <div className='flex flex-col w-half'>
                                    <label className='form-label'>Street 2:</label>
                                    <div className='px-3'>
                                        <input 
                                            placeholder="Input delivery street 2"
                                            name="de_To_Address_Street_2"
                                            type="text"
                                            value={formInputs['de_To_Address_Street_2'] ? formInputs['de_To_Address_Street_2'] : ''} 
                                            className={getInputClass('de_To_Address_Street_2')}
                                            onChange={(e) => this.onHandleInput(e)}
                                            disabled={isYP}
                                            maxLength='29'
                                        />
                                        {renderError('de_To_Address_Street_2')}
                                    </div>
                                </div>
                            </div>
                            <div className='flex flex-row'>
                                <div className='flex flex-col w-quarter'>
                                    <label className='form-label'>Country: <span className='required'/></label>
                                    <div className='px-3'>
                                        <input 
                                            placeholder="Input delivery country"
                                            name="de_To_Address_Country"
                                            type="text"
                                            value={formInputs['de_To_Address_Country'] ? formInputs['de_To_Address_Country'] : ''} 
                                            className={getInputClass('de_To_Address_Country')}
                                            onChange={(e) => this.onHandleInput(e)}
                                            disabled={isYP}
                                            maxLength='29'
                                        />
                                        {renderError('de_To_Address_Country')}
                                    </div>
                                </div>
                                <div className='flex flex-col w-quarter'>
                                    <label className='form-label'>Suburb: <span className='required'/></label>
                                    <div className='grow px-3'>
                                        <Select
                                            className={getInputClass('de_To_Address_Suburb')}
                                            value={deToSuburb}
                                            onChange={(e) => this.handleChangeSuburb(e, 'deToSuburb')}
                                            onInputChange={debounce((e) => this.handleInputChangeSuburb(e, 'deToSuburb'), 500)}
                                            options={deToAddressOptions}
                                            placeholder='Select suburb'
                                            noOptionsMessage={() => this.displayNoOptionsMessage()}
                                            filterOption={(options) => options}
                                            isDisabled={isYP}
                                        />
                                        {renderError('de_To_Address_Suburb')}
                                    </div>
                                </div>
                                <div className='flex flex-col w-quarter'>
                                    <label className='form-label'>Postal Code: <span className='required'/></label>
                                    <div className='px-3'>
                                        <input 
                                            placeholder="Input delivery postal code"
                                            name="de_To_Address_PostalCode"
                                            type="text"
                                            value={formInputs['de_To_Address_PostalCode'] ? formInputs['de_To_Address_PostalCode'] : ''} 
                                            className="form-control"
                                            onChange={(e) => this.onHandleInput(e)}
                                            maxLength='4'
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div className='flex flex-col w-quarter'>
                                    <label className='form-label'>State: <span className='required'/></label>
                                    <div className='px-3'>
                                        <select
                                            className='form-control px-3'
                                            name="de_To_Address_State"
                                            value={formInputs['de_To_Address_State']}
                                            onChange={(e) => this.onHandleInput(e)}
                                            disabled
                                        >
                                            <option value="" defaultValue="" disabled hidden>--- Please select state ---</option>
                                            <option value="NSW">NSW</option>
                                            <option value="NT">NT</option>
                                            <option value="QLD">QLD</option>
                                            <option value="SA">SA</option>
                                            <option value="VIC">VIC</option>
                                            <option value="ACT">ACT</option>
                                            <option value="WA">WA</option>
                                            <option value="TAS">TAS</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className='flex flex-row'>
                                <div className='flex flex-col w-quarter'>
                                    <label className='form-label'>Contact Name: <span className='required'/></label>
                                    <div className='px-3'>
                                        <input 
                                            placeholder="Input delivery contact name"
                                            name="de_to_Contact_F_LName"
                                            type="text"
                                            value={formInputs['de_to_Contact_F_LName'] ? formInputs['de_to_Contact_F_LName'] : ''} 
                                            className={getInputClass('de_to_Contact_F_LName')}
                                            onChange={(e) => this.onHandleInput(e)}
                                            disabled={isYP}
                                            maxLength='19'
                                        />
                                        {renderError('de_to_Contact_F_LName')}
                                    </div>
                                </div>
                                <div className='flex flex-col w-quarter'>
                                    <label className='form-label'>Phone: <span className='required'/></label>
                                    <div className='px-3'>
                                        <input 
                                            placeholder="Input delivery phone"
                                            name="de_to_Phone_Main"
                                            type="text"
                                            value={formInputs['de_to_Phone_Main'] ? formInputs['de_to_Phone_Main'] : ''} 
                                            className={getInputClass('de_to_Phone_Main')}
                                            onChange={(e) => this.onHandleInput(e)}
                                            disabled={isYP}
                                            maxLength={15}
                                            minLength={7}
                                        />
                                        {renderError('de_to_Phone_Main')}
                                    </div>
                                </div>
                                <div className='flex flex-col w-quarter'>
                                    <label className='form-label'>Email: <span className='required'/></label>
                                    <div className='px-3'>
                                        <input 
                                            placeholder="Input delivery email"
                                            name="de_Email"
                                            type="text"
                                            value={formInputs['de_Email'] ? formInputs['de_Email'] : ''} 
                                            className={getInputClass('de_Email')}
                                            onChange={(e) => this.onHandleInput(e)}
                                            disabled={isYP}
                                            maxLength='64'
                                        />
                                        {renderError('de_Email')}
                                    </div>
                                </div>
                                <div className='flex flex-col w-quarter'>
                                    <label className='form-label'>Address Type: <span className='required'/></label>
                                    <div className='px-3'>
                                        <select
                                            className={getInputClass('de_To_AddressType')}
                                            name="de_To_AddressType"
                                            value={formInputs['de_To_AddressType']}
                                            onChange={(e) => this.onHandleInput(e)}
                                            disabled={isYP}
                                        >
                                            <option value="" defaultValue="" disabled hidden>--- Please select option ---</option>
                                            <option value="business">Business</option>
                                            <option value="residential">Residential</option>
                                        </select>
                                        {renderError('de_To_AddressType')}
                                    </div>
                                </div>
                            </div>
                            <div className='flex flex-col'>
                                <label className='form-label'>Delivery Special Instruction:</label>
                                <div className='px-3'>
                                    <input 
                                        placeholder=""
                                        name="de_to_PickUp_Instructions_Address"
                                        type="text"
                                        value={formInputs['de_to_PickUp_Instructions_Address'] ? formInputs['de_to_PickUp_Instructions_Address'] : ''} 
                                        className={getInputClass('de_to_PickUp_Instructions_Address')}
                                        onChange={(e) => this.onHandleInput(e)}
                                        disabled={isYP}
                                        maxLength='29'
                                    />
                                    {renderError('de_to_PickUp_Instructions_Address')}
                                </div>
                            </div>
                            <div className='flex flex-row'>
                                <div className='mx-3 tail-lift flex p-2'>
                                    <div className='px-3 py-2'>
                                        <input
                                            name="b_booking_tail_lift_deliver"
                                            type="checkbox"
                                            data-method="Email"
                                            checked={formInputs['b_booking_tail_lift_deliver'] ? 'checked' : ''}
                                            onChange={(e) => this.onHandleInput(e)}
                                        />
                                    </div>
                                    <label className='form-label'>Tail Lift Required:</label>
                                </div>
                            </div>
                            <div className='flex flex-row mb-3'>
                                {/* <div className='flex flex-col w-half'>
                                    <label className='form-label'>Delivery From Date/Time:</label>
                                    <div className='px-3'>
                                        <DatePicker
                                            id="de_Deliver_From_Date"
                                            selected={deFromDT}
                                            onChange={(date) => this.onDateTimeChange(date, 'de-from')}
                                            dateFormat="dd MMM yyyy h:mm aa"
                                            showTimeSelect
                                            minDate={now}
                                        />
                                    </div>
                                </div> */}
                                <div className='flex flex-col w-half'>
                                    <label className='form-label'>Delivery From Date/Time:</label>
                                    <div className='px-3'>
                                        <DmeDateTimePicker
                                            className="form-control"
                                            selected={deFromDT}
                                            onChange={(date) => this.onDateTimeChange(date, 'de-from')}
                                            selectPastDates={false}
                                        />
                                    </div>
                                </div>
                                <div className='flex flex-col w-half'>
                                    <label className='form-label'>Delivery By Date/Time:</label>
                                    <div className='px-3'>
                                        <DmeDateTimePicker
                                            className="form-control"
                                            selected={deByDT}
                                            onChange={(date) => this.onDateTimeChange(date, 'de-by')}
                                            selectPastDates={false}
                                        />
                                    </div>
                                </div>
                                {/* <div className='flex flex-col w-half'>
                                    <label className='form-label'>Delivery By Date/Time:</label>
                                    <div className='px-3'>
                                        <DatePicker
                                            id="de_Deliver_By_Date"
                                            selected={deByDT}
                                            onChange={(date) => this.onDateTimeChange(date, 'de-by')}
                                            dateFormat="dd MMM yyyy h:mm aa"
                                            showTimeSelect
                                            minDate={now}
                                        />
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        <hr />
                        <section className='panel'>
                            <div className='panel-header justify-center'>
                                <h3 className='font-bold text-gradient'>Parcel information:</h3>
                            </div>
                            <div className='parcel p-3'>
                                <div className='flex flex-col'>
                                    <table className='parcel-table'>
                                        <thead className='text-center'>
                                            <tr>
                                                <th><span>Actions</span></th>
                                                <th><span>Package Type</span></th>
                                                <th><span>Qty</span></th>
                                                <th><span>Length (cm)</span></th>
                                                <th><span>Width (cm)</span></th>
                                                <th><span>Height (cm)</span></th>
                                                <th><span>Weight Each (kg)</span></th>
                                                <th>
                                                    <div className='row content-details flex items-center justify-center p-2'>
                                                        <span>Content Details</span>
                                                    </div>
                                                    <div className="row grow px-2">
                                                        <div className={isYP ? 'col-md-2 rect2' : 'col-md-1 rect2'}>
                                                            <span>Qty</span>
                                                        </div>
                                                        <div className={isYP ? 'col-md-4 rect2' : 'col-md-2 rect2'}>
                                                            <span>
                                                                {isAP ? 'Reference No. 1' : (isGWSubClient(formInputs['b_client_name']) ? 'GW Ref No. 1' : (isYP ? 'Store No' : 'Ref No. 1'))}
                                                            </span>
                                                        </div>
                                                        <div className={isYP ? 'none col-md-2 rect2' : 'col-md-2 rect2'}>
                                                            <span>
                                                                {isAP ? 'Reference No. 2' : (isGWSubClient(formInputs['b_client_name']) ? 'GW Ref No. 2' : (isYP ? 'RA Number' : 'Ref No. 2'))}
                                                            </span>
                                                        </div>
                                                        <div className={isYP ? 'col-md-4 rect2' : 'col-md-2 rect2'}>
                                                            <span>Model Number</span>
                                                        </div>
                                                        <div className={isYP ? 'none col-md-2 rect2' : 'col-md-2 rect2'}>
                                                            <span>Item Description</span>
                                                        </div>
                                                        <div className={isYP ? 'none col-md-2 rect2' : 'col-md-2 rect2'}>
                                                            <span>Fault Desc</span>
                                                        </div>
                                                        <div className={isYP ? 'none col-md-2 rect2' : 'col-md-1 rect2'}>
                                                            <span>Actions</span>
                                                        </div>
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {renderedLines}
                                        </tbody>
                                    </table>
                                    <div className='row mt-3'>
                                        <button className='btn btn-primary' onClick={(e) => this.onClickNewLine(e)}>
                                            <i className="icon icon-plus"></i> New Item
                                        </button>
                                    </div>
                                    <br/>
                                    {renderError('lines')}
                                </div>
                            </div>
                        </section>
                        <hr />
                        <section className='panel'>
                            <div className='panel-header justify-center'>
                                <h3 className='font-bold text-gradient'>Pallet Movement Details:</h3>
                            </div>
                            <div className='parcel p-3'>
                                <table className="pallet-table" border="1">
                                    <thead>
                                        <tr>
                                            <th rowSpan="2">Pallet Type</th>
                                            <th colSpan="3">Number of Pallets</th>
                                            <th rowSpan="2">Receiver Pallet Account Number</th>
                                            <th rowSpan="2">Pallet Transfer Docket Number</th>
                                        </tr>
                                        <tr>
                                            <th>Exchange to Carrier</th>
                                            <th>Transfer to Carrier</th>
                                            <th>Transfer to Receiver</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <input
                                                    id="has_plain_pallet"
                                                    name="has_plain_pallet"
                                                    className='form-control m-auto'
                                                    checked={formInputs['has_plain_pallet']}
                                                    type="checkbox"
                                                    onChange={(e) => this.onHandleInput(e)}
                                                />
                                                <label htmlFor="has_plain_pallet">Plain</label>
                                            </td>
                                            <td className="bg-lightgray">
                                            </td>
                                            <td className="bg-lightgray">
                                            </td>
                                            <td>
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    min={0}
                                                    step="1"
                                                    name="b_pallet_plain_transfer_to_receiver"
                                                    value={formInputs['b_pallet_plain_transfer_to_receiver'] ? formInputs['b_pallet_plain_transfer_to_receiver'] : ''}
                                                    onChange={(e) => this.onHandleInput(e)}
                                                />
                                            </td>
                                            <td className="bg-lightgray">
                                            </td>
                                            <td className="bg-lightgray">
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <input
                                                    id="has_chep_pallet"
                                                    name="has_chep_pallet"
                                                    className='form-control m-auto'
                                                    checked={formInputs['has_chep_pallet']}
                                                    type="checkbox"
                                                    onChange={(e) => this.onHandleInput(e)}
                                                />
                                                <label htmlFor="has_chep_pallet">Chep</label>
                                            </td>
                                            <td>
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    min={0}
                                                    step="1"
                                                    name="b_pallet_chep_exchange_to_carrier"
                                                    value={formInputs['b_pallet_chep_exchange_to_carrier'] ? formInputs['b_pallet_chep_exchange_to_carrier'] : ''}
                                                    onChange={(e) => this.onHandleInput(e)}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    min={0}
                                                    step="1"
                                                    name="b_pallet_chep_transfer_to_carrier"
                                                    value={formInputs['b_pallet_chep_transfer_to_carrier'] ? formInputs['b_pallet_chep_transfer_to_carrier'] : ''}
                                                    onChange={(e) => this.onHandleInput(e)}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    min={0}
                                                    step="1"
                                                    name="b_pallet_chep_transfer_to_receiver"
                                                    value={formInputs['b_pallet_chep_transfer_to_receiver'] ? formInputs['b_pallet_chep_transfer_to_receiver'] : ''}
                                                    onChange={(e) => this.onHandleInput(e)}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="b_pallet_chep_account"
                                                    value={formInputs['b_pallet_chep_account'] ? formInputs['b_pallet_chep_account'] : ''}
                                                    onChange={(e) => this.onHandleInput(e)}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="b_pallet_chep_docket_number"
                                                    value={formInputs['b_pallet_chep_docket_number'] ? formInputs['b_pallet_chep_docket_number'] : ''}
                                                    onChange={(e) => this.onHandleInput(e)}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <input
                                                    id="has_loscam_pallet"
                                                    name="has_loscam_pallet"
                                                    className='form-control m-auto'
                                                    checked={formInputs['has_loscam_pallet']}
                                                    type="checkbox"
                                                    onChange={(e) => this.onHandleInput(e)}
                                                />
                                                <label htmlFor="has_loscam_pallet">Loscam</label>
                                            </td>
                                            <td>
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    min={0}
                                                    step="1"
                                                    name="b_pallet_loscam_exchange_to_carrier"
                                                    value={formInputs['b_pallet_loscam_exchange_to_carrier'] ? formInputs['b_pallet_loscam_exchange_to_carrier'] : ''}
                                                    onChange={(e) => this.onHandleInput(e)}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    min={0}
                                                    step="1"
                                                    name="b_pallet_loscam_transfer_to_carrier"
                                                    value={formInputs['b_pallet_loscam_transfer_to_carrier'] ? formInputs['b_pallet_loscam_transfer_to_carrier'] : ''}
                                                    onChange={(e) => this.onHandleInput(e)}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    min={0}
                                                    step="1"
                                                    name="b_pallet_loscam_transfer_to_receiver"
                                                    value={formInputs['b_pallet_loscam_transfer_to_receiver'] ? formInputs['b_pallet_loscam_transfer_to_receiver'] : ''}
                                                    onChange={(e) => this.onHandleInput(e)}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="b_pallet_loscam_account"
                                                    value={formInputs['b_pallet_loscam_account'] ? formInputs['b_pallet_loscam_account'] : ''}
                                                    onChange={(e) => this.onHandleInput(e)}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="b_pallet_loscam_docket_number"
                                                    value={formInputs['b_pallet_loscam_docket_number'] ? formInputs['b_pallet_loscam_docket_number'] : ''}
                                                    onChange={(e) => this.onHandleInput(e)}
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </section>
                        <hr />
                        <section className='flex justify-end mb-3'>
                            <button
                                className="btn btn-danger mr-3"
                                onClick={() => this.resetForm()}
                                type='button'
                            >
                                Cancel
                            </button>
                            <button type="submit" form="booking-form" className="btn btn-primary">Detail Confirmed. Organize Pick-up</button>
                        </section>
                    </form>
                </LoadingOverlay>

                <SimpleLineModal
                    isOpen={isShowSimpleLineModal}
                    toggleModal={this.toggleSimpleLineModal}
                    packageTypes={packageTypes}
                    line={selectedLine}
                    editMode={selectedLine ? true : false}
                    createBookingLine={(line) => this.createBookingLine(line)}
                    updateBookingLine={(line) => this.updateBookingLine(line)}
                    deleteBookingLine={() => this.deleteBookingLine()}
                    isYP={isYP}
                />

                <SimpleLineDetailModal
                    isOpen={isShowSimpleLineDetailModal}
                    toggleModal={this.toggleSimpleLineDetailModal}
                    line={selectedLine}
                    lineDetail={selectedLineDetail}
                    editMode={selectedLineDetail ? true : false}
                    createBookingLineDetail={(line, lineDetail) => this.createBookingLineDetail(line, lineDetail)}
                    updateBookingLineDetail={(line, lineDetail) => this.updateBookingLineDetail(line, lineDetail)}
                    deleteBookingLineDetail={(line) => this.deleteBookingLineDetail(line)}
                    isYP={isYP}
                    isAP={isAP}
                    isGW={isGWSubClient(formInputs['b_client_name'])}
                />

                <ConfirmModal
                    isOpen={this.state.isShowConfirmModal}
                    onOk={() => this.onClickConfirmBtn()}
                    onCancel={() => this.onClickCancelBtn()}
                    title={'Booking is created successfully'}
                    text={'Would you like to view the booking details?'}
                    okBtnName={'Cancel'}
                    cancelBtnName={'Go To Created Booking'}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        redirect: state.auth.redirect,
        clientname: state.auth.clientname,
        clientId: state.auth.clientId,
        username: state.auth.username,
        dmeClients: state.auth.dmeClients,
        puContacts: state.elasticsearch.puContacts,
        deContacts: state.elasticsearch.deContacts,
        puAddresses: state.elasticsearch.puAddresses,
        deToAddresses: state.elasticsearch.deToAddresses,
        packageTypes: state.extra.packageTypes,
        booking: state.booking.booking,
        errorMessage: state.booking.errorMessage,
        quickQuoteBookingData: state.booking.quickQuoteBookingData
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getUser: (token) => dispatch(getUser(token)),
        getDMEClients: () => dispatch(getDMEClients()),
        cleanRedirectState: () => dispatch(cleanRedirectState()),
        getContactsOfClient: (src, prefix, clientName) => dispatch(getContactsOfClient(src, prefix, clientName)),
        getContactsWithPrefix: (src, prefix, clientName) => dispatch(getContactsWithPrefix(src, prefix, clientName)),
        getContactsWithStoreNo: (src, storeNo, clientName) => dispatch(getContactsWithStoreNo(src, storeNo, clientName)),
        getAddressesWithPrefix: (src, suburbPrefix, postalCodePrefix) => dispatch(getAddressesWithPrefix(src, suburbPrefix, postalCodePrefix)),
        getPackageTypes: () => dispatch(getPackageTypes()),
        saveBooking: (booking, line) => dispatch(saveBooking(booking, line)),
        resetQuickQuoteBookingData: () => dispatch(resetQuickQuoteBookingData())
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewBookingPage));



// WEBPACK FOOTER //
// ./src/pages/NewBookingPage.js